import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const Footer: React.FC = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const t = translations[language];

  const prefix = language === 'fr' ? '' : `/${language}`;
  const homePath = prefix || '/';
  const isHome =
    location.pathname === '/' ||
    location.pathname === '/en' ||
    location.pathname === '/es';

  const scrollToSection = (id: string) => {
    if (!isHome) {
      navigate(homePath);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const offset = 70;
          window.scrollTo({
            top: el.getBoundingClientRect().top + window.pageYOffset - offset,
            behavior: 'smooth',
          });
        }
      }, 150);
    } else {
      const el = document.getElementById(id);
      if (el) {
        const offset = 70;
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.pageYOffset - offset,
          behavior: 'smooth',
        });
      }
    }
  };

  return (
    <footer className="page-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-company">
            <div className="footer-logo">
              <img src="/images/logo.png" alt="Sparkr Logo" className="footer-logo-img" />
            </div>
            <p className="footer-description">{t.footer.description}</p>
          </div>

          <div className="footer-section">
            <h6 className="footer-title">{t.footer.quickLinks}</h6>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('hero')}>{t.nav.home}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('mission')}>{t.nav.mission}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('clients')}>{t.nav.clients}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')}>{t.nav.about}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')}>{t.nav.contact}</button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h6 className="footer-title">{t.footer.services}</h6>
            <ul className="footer-links">
              {t.offerPages.map((offer) => (
                <li key={offer.id}>
                  <Link to={`${prefix}/offers/${offer.slug}`}>{offer.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h6 className="footer-title">{t.footer.contact}</h6>
            <ul className="footer-links">
              <li>
                <a href={`mailto:${t.contact.email}`}>{t.contact.email}</a>
              </li>
            </ul>

            <h6 className="footer-title footer-legal-title">{t.footer.followUs}</h6>
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/spark-r"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="footer-social-link"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p>{t.footer.copyright} {t.footer.allRightsReserved}</p>
      </div>
    </footer>
  );
};

export default Footer;
